export enum PhoneCountryCodeEnum {
  RWANDA = "RW",
  UGANGA = "UG",
  KENYA = "KE",
  TANZANIA = "TZ",
  BURUNDI = "BI",
  DR_CONGO = "CD"
}

export interface PhoneCountryCodeItem {
  code: string;
  countryCode: PhoneCountryCodeEnum;
  flag: string;
}

export const phoneCountryCodeMap: {
  [key in PhoneCountryCodeEnum]: PhoneCountryCodeItem;
} = {
  [PhoneCountryCodeEnum.RWANDA]: {
    code: "+250",
    countryCode: PhoneCountryCodeEnum.RWANDA,
    flag: "🇷🇼"
  },
  [PhoneCountryCodeEnum.UGANGA]: {
    code: "+256",
    countryCode: PhoneCountryCodeEnum.UGANGA,
    flag: "🇺🇬"
  },
  [PhoneCountryCodeEnum.KENYA]: {
    code: "+254",
    countryCode: PhoneCountryCodeEnum.KENYA,
    flag: "🇰🇪"
  },
  [PhoneCountryCodeEnum.TANZANIA]: {
    code: "+255",
    countryCode: PhoneCountryCodeEnum.TANZANIA,
    flag: "🇹🇿"
  },
  [PhoneCountryCodeEnum.BURUNDI]: {
    code: "+257",
    countryCode: PhoneCountryCodeEnum.BURUNDI,
    flag: "🇧🇮"
  },
  [PhoneCountryCodeEnum.DR_CONGO]: {
    code: "+243",
    countryCode: PhoneCountryCodeEnum.DR_CONGO,
    flag: "🇨🇩"
  }
};
